import { DecodoComponentsMap } from '@/components/cms/components-decodo-list';
import { Block } from '@/components/cms/types/block';

import { PageData } from '@/app/types';

export interface CMSComponentProps {
  block: Block;
  pageData?: PageData;
  componentsList: typeof DecodoComponentsMap;
  backgroundColor?: string;
}

export function CMSComponent({
  block,
  componentsList,
  ...restProps
}: CMSComponentProps) {
  if (!block) {
    // eslint-disable-next-line no-console
    console.error("Please provide a 'block' property to the CMSComponent");
    return <div>Please provide a block property to the CMSComponent</div>;
  }
  if (block) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const Component = getComponent(block.__component, componentsList);
    if (Component) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return <Component block={block} {...restProps} />;
    }
  }
  return <></>;
}

function getComponent(
  componentKey: string,
  componentsList: typeof DecodoComponentsMap
) {
  if (!componentsList[componentKey]) {
    // eslint-disable-next-line no-console
    console.error(`Component ${componentKey} doesn't exist.`);
    return false;
  }
  return componentsList[componentKey];
}
